import Text from 'components/Text'
import {
  STYLES_COLOR,
  STYLES_FONT_SIZE,
  STYLES_FONT_WEIGHT
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

function TextTitleLight (props) {
  return (
    <Text
      {...props}
      style={{
        fontSize: STYLES_FONT_SIZE.HEADING_SMALL,
        fontWeight: STYLES_FONT_WEIGHT.LIGHT,
        color: STYLES_COLOR.BLACK_LIGHT,
        display: 'block',
        ...props.style
      }}
    >
      {props.children}
    </Text>
  )
}

TextTitleLight.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  style: PropTypes.object
}

TextTitleLight.defaultTypes = {
  style: {}
}

export default TextTitleLight
